<template>
  <div v-if="dataReady" @click="openInCart" class="listing-map-offer" ref="offer">
    <div class="listing-map-offer__image"
      :style="{
        backgroundImage: `url(${offer.Hotel_ListingImageUrl}?h=180)`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        height: '180px',
      }">
      <div class="listing-map-offer__hotel-price">
        <div v-if="priceType == 'person'" class="listing-map-offer__hotel-price--value">
          {{ offer.Merlin_AdultPrice }}
          <span class="listing-map-offer__hotel-price--currency">zł</span>
        </div>
        <div v-if="priceType == 'group'" class="listing-map-offer__hotel-price--value">
          {{ offer.Merlin_FullPriceParsed }}
          <span class="listing-map-offer__hotel-price--currency">zł</span>
        </div>
      </div>
    </div>
    <div class="listing-map-offer__content">
      <div class="listing-map-offer__hotel-name">{{ offer.Hotel_Name }}</div>
      <div :class="[ 'stars', 'stars--lightblue', offer.Hotel_Standard_Stars_Css, 'listing-map-offer__hotel-standard' ]" />
      <div v-if="ratingMoreThanZero" class="listing-map-offer__hotel-rating">
        Opinie <span><strong>{{ offer.Hotel_AverageRating }}</strong> / 6</span>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import DataReadyMixin from '@/components/DataReadyMixin'
import ListingMapMixin from '@/components/googleMap/ListingMapMixin'
import { offersListFilterChanged } from '@/events'

@Component({
  mixins: [
    DataReadyMixin,
    ListingMapMixin,
  ],
  props: {
    offer: {
      type: Object,
      required: true,
    },
    googleMap: {
      type: Object,
      required: true,
    },
    priceType: {
      type: String,
      required: true,
    },
  },
})
export default class ListingMapOffer extends Vue {
  ratingMoreThanZero = parseInt(this.offer.Hotel_AverageRating) > 0

  created () {
    this.markDataAsReady()
  }

  mounted () {
    this.toggleParentClass()
    this.closeOfferOnMapClick()
    offersListFilterChanged.subscribe(this.updateOfferPriceType)
  }
  
  updateOfferPriceType (e, { priceType } = e.detail) {
    this.priceType = priceType
  }

  openInCart () {
    window.open(this.offer.url, '_blank')
  }

  toggleParentClass () {
    if (this.dataReady) this.$refs.offer.parentElement.classList.add('listing-map__wrapper--offer-wrapper')
  }

  closeOfferOnMapClick () {
    google.maps.event.addListener(this.googleMap, 'click', () => {
      if (this.offerListWrapperExist()) {
        this.offerListWrapperExist().classList.remove('listing-map__wrapper--offer-wrapper')
      }

      this.dataReady = false
    })
  }
}
</script>

<style lang="scss">
.listing-map-offer {
  font-size: 40px;
  position: absolute;
  width: 300px;
  height: auto;
  bottom: 6px;
  left: -119px;
  background: #fff;
  z-index: 200;
  box-shadow: 0px 1px 8px -4px #000;

  &::after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 13px 10px 0 10px;
    border-color: #fff transparent transparent transparent;
    bottom: -13px;
    left: calc(50% - 10px);
  }

  &__image {
    position: relative;
  }

  &__hotel-price {
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 5px;
    width: 122px;
    font-weight: 700;
    font-size: 26px;
    color: #fff;
    font-family: 'Gotham';
    text-align: center;
    background-color: #005ca9;

    &--currency {
      font-size: 10px;
      text-transform: uppercase;
      display: inline-block;
      vertical-align: top;
      margin-top: 6px;
      margin-left: -6px;
    }
  }

  &__hotel-name {
    color: #535353;
    font-size: 12px;
    font-family: 'Gotham';
    max-width: 150px;
    text-transform: uppercase;
  }

  &__hotel-standard {
    margin-top: 3px;
  }

  &__hotel-rating {
    float: right;
    font-family: 'Gotham Book';
    font-weight: normal;
    color: #535353;
    font-size: 13px;
    text-transform: uppercase;
    margin-top: -16px;

    span {
      font-size: 15px;
      color: #009FEA;
    }

    strong {
      font-size: 18px;      
    }
  }

  &__content {
    padding: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/googleMap/ListingMapOffer.vue